import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Question\CreateQuestionController::__invoke
* @see app/Http/Controllers/Question/CreateQuestionController.php
* @route '/api/question'
*/
const CreateQuestionController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateQuestionController.url(options),
    method: 'post',
})

CreateQuestionController.definition = {
    methods: ["post"],
    url: '/api/question',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Question\CreateQuestionController::__invoke
* @see app/Http/Controllers/Question/CreateQuestionController.php
* @route '/api/question'
*/
CreateQuestionController.url = (options?: RouteQueryOptions) => {
    return CreateQuestionController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Question\CreateQuestionController::__invoke
* @see app/Http/Controllers/Question/CreateQuestionController.php
* @route '/api/question'
*/
CreateQuestionController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateQuestionController.url(options),
    method: 'post',
})

export default CreateQuestionController